import React from 'react'

function Merm_result() {
  return (
    <div>mid-term_result</div>
  )
}

export default Merm_result